import elementService from "@/common/ElementService";

export default new class ShowMoreDescriptionTextService {
    public init(): void {
        for (const showMoreTextButton of document.querySelectorAll<HTMLAnchorElement>(".js-more-text")) {
            const parentParagraph = elementService.closest<HTMLParagraphElement>(showMoreTextButton, "div");

            parentParagraph.addEventListener("click", (event: MouseEvent) => {
                event.preventDefault();
                this.showMoreText(parentParagraph);
            });
        }
    }

    private showMoreText(parentParagraph: HTMLParagraphElement): void {
        const textExcerpt = elementService.elementQuerySelector<HTMLSpanElement>(parentParagraph, ".js-text-excerpt");
        const extraData = elementService.elementQuerySelector<HTMLSpanElement>(parentParagraph, ".extra-data");
        const showMoreText = elementService.elementQuerySelector<HTMLSpanElement>(parentParagraph, ".js-more-text");

        showMoreText.classList.add("hidden");
        textExcerpt.classList.add("hidden");
        extraData.classList.remove("hidden");
    }
}();
